import { LazyTranslateLoader } from '../utils/lazy-translate-loader';

export function TranslateLoaderFactory(): LazyTranslateLoader {
    return new LazyTranslateLoader();
}
